<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("TAXES.ADD_TAX") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <tax-form
              :loading="loading"
              :taxData="tax"
              :formErrors="formErrors"
              @taxesubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultTax from "./defaultTax";
import TaxForm from "./partials/TaxForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    TaxForm,
  },

  mixins: [alertLeave],

  data() {
    return {
      tax: cloneDeep(defaultTax),
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    goBack() {
      this.$router.push({ name: "List Taxes" });
    },

    viewTax(tax) {
      this.alertLeave = false;
      this.$router.push({ name: "View Tax", params: { id: tax.id } });
    },

    async handleSubmit(tax) {
      this.loading = true;

      const taxData = cloneDeep(tax);
      delete taxData.id;
      if (!taxData.organization.id) {
        delete taxData.organization;
      }

      try {
        await this.$store.dispatch("taxes/add", taxData);
        this.$notify({
          type: "success",
          message: this.$t("TAXES.TAX_ADDED"),
        });
        const tax = await this.$store.getters["taxes/tax"];
        this.viewTax(tax);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        const tax = await this.$store.getters["taxes/tax"];
        if (tax.id) {
          await this.$store.dispatch("taxes/destroy", tax.id);
        }
        this.loading = false;
      }
    },
  },
};
</script>
